import { LocationAlarmCamera } from '@hakimo-ui/hakimo/types';
import { Popover, Transition } from '@headlessui/react';
import { ChevronDownIcon, VideoCameraIcon } from '@heroicons/react/24/outline';
import { Fragment } from 'react';
import { CameraSelectPanel, nameOf } from './CameraSelectPanel';

interface Props {
  cameras: LocationAlarmCamera[];
  value: LocationAlarmCamera[];
  onChange: (cameras: LocationAlarmCamera[]) => void;
}

export function TalkdownCameraPicker(props: Props) {
  const { cameras, value, onChange } = props;

  const label =
    value.length === 0
      ? 'Select cameras'
      : value.length === 1
      ? nameOf(value[0])
      : `${value.length} Cameras`;

  return (
    <Popover className="relative">
      <Popover.Button
        title={value.length ? value.map(nameOf).join(', ') : 'Select cameras'}
        className="dark:bg-ondark-bg-1 bg-onlight-bg-1 text-onlight-text-2 dark:text-ondark-text-2 hover:text-onlight-text-1 dark:hover:text-ondark-text-1 focus-visible:ring-primary-500 flex items-center gap-1 rounded-full px-2 py-1 focus:outline-none focus-visible:ring-1"
      >
        <VideoCameraIcon className="h-4 w-4 shrink-0" />
        <span className="max-w-[7rem] truncate text-xs">{label}</span>
        <ChevronDownIcon className="h-3 w-3 shrink-0" />
      </Popover.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Popover.Panel className="absolute right-0 top-full z-30 mt-2 w-64 max-w-[90vw]">
          {({ close }) => (
            <CameraSelectPanel
              cameras={cameras}
              value={value}
              onSubmit={(selected) => {
                onChange(selected);
                close();
              }}
              onCancel={close}
            />
          )}
        </Popover.Panel>
      </Transition>
    </Popover>
  );
}

export default TalkdownCameraPicker;
